import React, { ReactNode, useRef } from "react";
import PropTypes from "prop-types";
import { createPolymorphicComponent } from "@mantine/core";
import {
  CellContext,
  ColumnDefTemplate,
  DeepKeys,
  HeaderContext,
  RowData,
} from "@tanstack/react-table";
import {
  MRT_Cell,
  MRT_Column,
  MRT_ColumnDef,
  MRT_Row,
  MRT_TableInstance,
} from "mantine-react-table";

export interface IColumnProps<TData extends Record<string, any> = {}>
  extends MRT_ColumnDef<TData> {
  fieldName?: DeepKeys<TData>;
}

export const _Column: React.FC<IColumnProps<any>> = (props) => {
  const itemRef = useRef<any>();

  return null;
};

const propTypes = {
  fieldName: PropTypes.string,
  size: PropTypes.number,
  minSize: PropTypes.number,
  fixed: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.oneOf(["left", "right"]),
  ]),
  resizable: PropTypes.bool,
  sortable: PropTypes.bool,
  cell: PropTypes.func,
  children: PropTypes.node,
};

_Column.displayName = "ReactTable.Column";
_Column.defaultProps = {};

export const Column =
  createPolymorphicComponent<"div", IColumnProps<any>>(_Column);
